var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "office_1_",
    d: "M31,31.36H1c-0.199,0-0.36-0.161-0.36-0.36V1c0-0.199,0.161-0.36,0.36-0.36h18c0.199,0,0.36,0.161,0.36,0.36 v2.64H25c0.199,0,0.36,0.161,0.36,0.36v3.64H31c0.199,0,0.36,0.161,0.36,0.36v23C31.36,31.199,31.199,31.36,31,31.36z M19.36,30.64 h11.28V8.36H19.36V30.64z M12.36,30.64h6.28V1.36H1.36v29.28h6.28V23c0-0.199,0.161-0.36,0.36-0.36h4c0.199,0,0.36,0.161,0.36,0.36 V30.64z M8.36,30.64h3.28v-7.28H8.36V30.64z M19.36,7.64h5.279V4.36H19.36V7.64z M27.36,25h-0.72v-2h0.721L27.36,25L27.36,25z  M23.36,25h-0.72v-2h0.721L23.36,25L23.36,25z M16.36,25h-0.72v-2h0.72V25z M4.36,25H3.64v-2h0.72V25z M27.36,19h-0.72v-2h0.721 L27.36,19L27.36,19z M23.36,19h-0.72v-2h0.721L23.36,19L23.36,19z M16.36,19h-0.72v-2h0.72V19z M12.36,19h-0.72v-2h0.72V19z  M8.36,19H7.64v-2h0.72V19z M4.36,19H3.64v-2h0.72V19z M27.36,13h-0.72v-2h0.721L27.36,13L27.36,13z M23.36,13h-0.72v-2h0.721 L23.36,13L23.36,13z M16.36,13h-0.72v-2h0.72V13z M12.36,13h-0.72v-2h0.72V13z M8.36,13H7.64v-2h0.72V13z M4.36,13H3.64v-2h0.72V13z  M16.36,7h-0.72V5h0.72V7z M12.36,7h-0.72V5h0.72V7z M8.36,7H7.64V5h0.72V7z M4.36,7H3.64V5h0.72V7z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.b7cabdae5949f09d6e25dd20be51039f.svg";
export { ForwardRef as ReactComponent };